import React from "react";
import CustomButton from "../../../components/CustomButton/CustomButton";
import Text from "../../../components/Common/Text";
import { LoginContainer, FormLogin, LoginStyles } from "../styles/LoginStyles";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import useEmpresa from "../../../hooks/useEmpresa";
import { EMPRESA } from "../../../utils/Constant";

const LoginForm = ({
  data,
  onStateChange,
  handleKeyPress,
  onLogin,
  isLoading,
  showRequired,
}) => {
  const { codigo, pin } = data;
  const empresa = useEmpresa();

  const marginRight =
    empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO ? "250px" : null;

  return (
    <LoginContainer marginRight={marginRight}>
      <Text size="17px" isTittle={true} weight={"bold"}>
        Bienvenido a Autorizaciones en línea
      </Text>

      <FormLogin>
        <CustomInput
          type={"text"}
          placeholder={"Usuario"}
          label={"Usuario"}
          width={LoginStyles.inputLoginWidth}
          height={LoginStyles.inputLoginHeight}
          value={codigo}
          required={true}
          showRequired={showRequired}
          onChange={onStateChange("codigo")}
          handleKeyPress={handleKeyPress}
          disabled={isLoading}
        />
        <CustomSeparator height={"10px"} />
        <CustomInput
          type={"password"}
          placeholder={"Contraseña"}
          label={"Contraseña"}
          width={LoginStyles.inputLoginWidth}
          height={LoginStyles.inputLoginHeight}
          value={pin}
          required={true}
          showRequired={showRequired}
          onChange={onStateChange("pin")}
          handleKeyPress={handleKeyPress}
          disabled={isLoading}
        />
        <CustomSeparator height={"10px"} />
        <CustomButton
          label={"Iniciar Sesión"}
          isLoading={isLoading}
          width={LoginStyles.buttonLoginWidth}
          weight={"bold"}
          onClick={onLogin}
          disabled={isLoading}
        />
      </FormLogin>
    </LoginContainer>
  );
};

export default LoginForm;
